import { type ReactNode, Children, type ExoticComponent } from 'react';

import { isSlot } from '../../../../../../core/utils/is-slot.js';
import { Chart } from '../slots/Chart.js';
import { Icon } from '../slots/Icon/Icon.js';
import { Label } from '../slots/Label/Label.js';
import { Legend } from '../slots/Legend.js';
import { Max } from '../slots/Max/Max.js';
import { Min } from '../slots/Min/Min.js';
import { Providers } from '../slots/Providers.js';
import { Thresholds } from '../slots/Thresholds.js';
import { Value } from '../slots/Value/Value.js';

/**
 * Function that selects all the meter bar layout slots from the children, and returns them identified.
 * @param children - Children for the MeterBarLayout. Should have the Label, Value, Chart and MinMaxLabel areas.
 * @returns An object with each children identified.
 */
export function extractSlots(children?: ReactNode) {
  const areas: {
    label?: ReactNode;
    min?: ReactNode;
    max?: ReactNode;
    chart?: ReactNode;
    value?: ReactNode;
    icon?: ReactNode;
    legend?: ReactNode;
    thresholds?: ReactNode;
    providers?: { Component: ExoticComponent; props: Record<string, unknown> };
  } = {};

  Children.forEach(children, (child) => {
    if (isSlot(child, Label)) {
      areas.label = child;
    } else if (isSlot(child, Icon)) {
      areas.icon = child;
    } else if (isSlot(child, Value)) {
      areas.value = child;
    } else if (isSlot(child, Chart)) {
      areas.chart = child;
    } else if (isSlot(child, Min)) {
      areas.min = child;
    } else if (isSlot(child, Max)) {
      areas.max = child;
    } else if (isSlot(child, Legend)) {
      areas.legend = child;
    } else if (isSlot(child, Thresholds)) {
      areas.thresholds = child;
    } else if (isSlot(child, Providers)) {
      areas.providers = {
        Component: child.props.providerName as ExoticComponent,
        props: child.props.providerProps,
      };
    }
  });

  return areas;
}
